import { render, staticRenderFns } from "./musicPlayer.vue?vue&type=template&id=4974bef0&scoped=true&"
import script from "./musicPlayer.vue?vue&type=script&lang=js&"
export * from "./musicPlayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4974bef0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xc01/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4974bef0')) {
      api.createRecord('4974bef0', component.options)
    } else {
      api.reload('4974bef0', component.options)
    }
    module.hot.accept("./musicPlayer.vue?vue&type=template&id=4974bef0&scoped=true&", function () {
      api.rerender('4974bef0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/dashboard/component/musicPlayer.vue"
export default component.exports